<template lang="pug">
  erp-view(id="Aplicaciones" ref="Aplicaciones" title="Módulos" hide-header-title hide-header-action)
    template(slot="content")
      div(style="height: calc(100vh - 35px)")
        Noticias(ref="NoticiasPop")
        br
        div(style="vertical-align: center; text-align: center; width: 100% !important;")
          p.saludo.dx-field Hola 
            b {{ $store.state.seguridad.usuario ? $store.state.seguridad.usuario.name : "" }}
            | , elige el módulo que deseas usar:
          br
          dx-text-box.busqueda(ref="busqueda" v-model="busqueda" placeholder="Buscar aplicación" value-change-event="keyup" :show-clear-button="true" class="editable")
          br
          br
          .dx-field(style="font-size: 1.2em;") Aplicaciones web
          br
          .ed-grid.s-grid-3.m-grid-7.rows-gap.gap-1.contenedor-ajustable
            .item-grilla(v-for="app in aplicaciones" v-if="app.web")
              .modulo.dx-field(@click="ir(app)")
                br
                img(v-if="app.icono && app.icono.startsWith('data')" :src="app.icono" height="40" width="40")
                i(v-if="app.icono && !app.icono.startsWith('data')" :class="app.icono" :style="{ color: app.color, fontSize: '3.3em' }")
                p {{ app.nombre }}
          br
          .dx-field(style="font-size: 1.2em") Aplicaciones de escritorio
          br
          .ed-grid.s-grid-3.m-grid-7.rows-gap.gap-1.contenedor-ajustable
            .item-grilla(v-for="app in aplicaciones" v-if="!app.web")
              .modulo.dx-field(@click="ir(app)")
                br
                img(:src="app.icono" height="40" width="40")
                p {{ app.nombre }}
          br
          dx-button(:use-submit-behavior="true" text="Cerrar Sesión" type="default" styling-mode="outlined" @click="cerrarSesion")
        br
        br
</template>
<script>
import notify from "devextreme/ui/notify";
import Gestion from "@/components/seguridad/api/Gestion.js";
import MessageBox from "@/components/MessageBox.js"; 
import BrowserScan from "@/components/BrowserScan";

export default {
  components: {
    DxButton: require("devextreme-vue/button").DxButton,
    DxTextBox: require("devextreme-vue/text-box").DxTextBox
  },
  data: () => ({
    busqueda: ""
  }),
  methods: {
    ir(app) {
      this.$refs.Aplicaciones.wait();
      Gestion.registrarAcceso(app)
        .then(() => {
          let localUrl = process.env["VUE_APP_MODULO_" + app.id];
           //let jwt = this.$store.state.seguridad.token; 
          let url = app.url;
           
           // //console.log(jwt); // eslint-disable-line  
          
           //if (jwt && app.grupo === "VISUAL") {
              // Si la URL ya tiene parámetros, usamos "&"
            //   if (url.includes("?")) {
              //   url += "&jwt=" + encodeURIComponent(jwt);
             //  } else {
              //   url += "?jwt=" + encodeURIComponent(jwt);
              // }
            // }
            
          if (localUrl) {
            url = localUrl;
          }
          
          let esMovil = process.env.NODE_ENV == "development" ? "dev" : BrowserScan.isMobile() ? "movil" : "web";
          
          if (esMovil == "movil") {
            console.log("Estás accediendo desde un dispositivo móvil."); // eslint-disable-line
            console.log(url); // eslint-disable-line 
            url = url.replace("https://par1-intranetserverprd", "https://cartonesdelpacifico.com.pe");
          } 

          if (app.web) {
             
            let win = window.open(url, "_blank"); 

            if (win) {
              win.focus();
            } else {
              alert("Habilite las ventanas emergentes para este sitio web");
            }
          } else {
            window.location.href = url; 

          }
        })
        .catch(err => {
          console.log(err, err.response); //eslint-disable-line
          let response = err.response;
          if (!response) {
            notify(
              `No se puede establecer conexión con el servidor: ${err.config.url}`,
              "error",
              5000
            );
          } else if (response.status == 401) {
            this.cerrarSesion();
          } else {
            notify(response.data ? response.data : response, "error", 5000);
          }
        })
        .finally(() => {
          this.$refs.Aplicaciones.wait(false);
        });
    },
    cerrarSesion() {
      Gestion.cerrarSesion()
        .then()
        .catch();
    }
  },
  mounted() { 

    this.$store.commit("seguridad/setModulos", []);
    let urlToRedirect = this.$route.query.redirectTo;
    if (urlToRedirect) {
      window.location = urlToRedirect;
    } else {
      let token = this.$store.state.seguridad.token;
      while (token == null) {
        token = this.$store.state.seguridad.token;
      }
    }
    this.$refs.Aplicaciones.wait();
    this.$NoticiaResource.obtenerNoticia().then(res => {
      let noticia = res.data;
      if (noticia) {
        this.$refs.NoticiasPop.show(noticia);
      }
    });
    Gestion.obtenerModulos()
      .then(res => {
        this.$store.commit("seguridad/setModulos", res.data);
        this.$refs["busqueda"].instance.focus();
        this.$refs.Aplicaciones.wait(false);
      })
      .catch(err => {
        MessageBox.handleError(err);
        this.$store.commit("seguridad/setModulos", []);
        this.$refs.Aplicaciones.wait(false);
      });
  },
  computed: {
    aplicaciones() {
      let modulos = this.$store.state.seguridad.modulos;
      if (!this.busqueda) {
        return modulos;
      } else {
        let modulosFiltrados = [];
        modulos.forEach(m => {
          if (m.nombre.toLowerCase().includes(this.busqueda.toLowerCase())) {
            modulosFiltrados.push(m);
          }
        });
        return modulosFiltrados;
      }
    }
  }
};
</script>
<style scoped>
.modulo {
  cursor: pointer;
  padding: 1px;
  box-sizing: border-box;
  height: 100%;
}

.vertical-center {
  width: 100%;
  text-align: center;
}

h5 {
  margin-top: 0.7em;
}

.contenedor-ajustable {
  max-width: 900px !important;
}

.item-grilla {
  width: 120px;
  height: auto;
  box-sizing: border-box;
}

.modulo:hover {
  background-color: #ddd;
  color: #0061ae;
  text-decoration: underline;
}

@media (max-width: 800px) {
  .contenedor-ajustable {
    max-width: 300px !important;
  }
}

/*.saludo {
  padding-left: 2em;
  padding-right: 2em;
}*/

.busqueda {
  margin-left: 2em;
  margin-right: 2em;
  min-width: 300px;
  display: inline-block;
}
</style>
